"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.comReducer = comReducer;
var _types = require("./types");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initialState = {
  connected: false,
  connectionState: _types.ConnectionState.None,
  commandQueue: [],
  command: undefined,
  commandPause: true,
  storedFeatureCommand: undefined
};
function comReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.COMMAND_PAUSE:
      {
        return Object.assign({}, state, {
          commandPause: true
        });
      }
    case _types.COMMAND_RESUME:
      {
        return Object.assign({}, state, {
          commandPause: false
        });
      }
    case _types.COMMAND_PLAY:
      {
        return Object.assign({}, state, {
          command: action.payload
        });
      }
    case _types.COMMAND_QUEUE:
      {
        return Object.assign({}, state, {
          commandQueue: [].concat(_toConsumableArray(state.commandQueue), [action.payload])
        });
      }
    case _types.COMMAND_QUEUE_NEXT:
      {
        return Object.assign({}, state, {
          command: state.commandQueue.shift(),
          commandQueue: _toConsumableArray(state.commandQueue)
        });
      }
    case _types.RECONNECTED:
    case _types.CONNECTED:
      {
        return Object.assign({}, state, {
          connected: true,
          connectionState: _types.ConnectionState.Connected
        });
      }
    case _types.CONNECT:
      {
        return Object.assign({}, state, {
          connectionState: _types.ConnectionState.Connecting
        });
      }
    case _types.CONNECTION_FAILED:
      {
        return Object.assign({}, state, {
          connectionState: _types.ConnectionState.Failed
        });
      }
    case _types.DISCONNECTED:
      {
        return Object.assign({}, state, {
          connected: false,
          connectionState: _types.ConnectionState.Disconnected
        });
      }
    case _types.RECONNECTING:
      {
        return Object.assign({}, state, {
          connectionState: _types.ConnectionState.Reconnecting
        });
      }
    case _types.COMMAND_FEATURE_STORE:
      {
        return Object.assign({}, state, {
          storedFeatureCommand: action.payload
        });
      }
    case _types.COMMAND_FEATURE_STORE_CLEAR:
      {
        return Object.assign({}, state, {
          storedFeatureCommand: undefined
        });
      }
    case _types.SKIP_TO_COMMAND:
      {
        var newState = Object.assign({}, state, {});
        while (newState.commandQueue[0].type != action.payload.type) {
          newState.commandQueue.shift();
        }
        return newState;
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map